/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InputDirection } from './InputDirection';
import {
    InputDirectionFromJSON,
    InputDirectionFromJSONTyped,
    InputDirectionToJSON,
} from './InputDirection';

/**
 * 
 * @export
 * @interface InputAdminZone
 */
export interface InputAdminZone {
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminZone
     */
    allowAdditionalMissionTime?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputAdminZone
     */
    centerCoordinates?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InputAdminZone
     */
    dambaIntegration?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputAdminZone
     */
    deltaLink?: string;
    /**
     * 
     * @type {Array<InputDirection>}
     * @memberof InputAdminZone
     */
    directions?: Array<InputDirection>;
    /**
     * 
     * @type {number}
     * @memberof InputAdminZone
     */
    flightTimeoutMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminZone
     */
    leftZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminZone
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminZone
     */
    otgId: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminZone
     */
    radius?: number;
    /**
     * 
     * @type {number}
     * @memberof InputAdminZone
     */
    rightZoneId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputAdminZone
     */
    signalLink?: string;
}

/**
 * Check if a given object implements the InputAdminZone interface.
 */
export function instanceOfInputAdminZone(value: object): boolean {
    if (!('flightTimeoutMinutes' in value)) return false;
    if (!('name' in value)) return false;
    if (!('otgId' in value)) return false;
    return true;
}

export function InputAdminZoneFromJSON(json: any): InputAdminZone {
    return InputAdminZoneFromJSONTyped(json, false);
}

export function InputAdminZoneFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminZone {
    if (json == null) {
        return json;
    }
    return {
        
        'allowAdditionalMissionTime': json['allowAdditionalMissionTime'] == null ? undefined : json['allowAdditionalMissionTime'],
        'centerCoordinates': json['centerCoordinates'] == null ? undefined : json['centerCoordinates'],
        'dambaIntegration': json['dambaIntegration'] == null ? undefined : json['dambaIntegration'],
        'deltaLink': json['deltaLink'] == null ? undefined : json['deltaLink'],
        'directions': json['directions'] == null ? undefined : ((json['directions'] as Array<any>).map(InputDirectionFromJSON)),
        'flightTimeoutMinutes': json['flightTimeoutMinutes'],
        'leftZoneId': json['leftZoneId'] == null ? undefined : json['leftZoneId'],
        'name': json['name'],
        'otgId': json['otgId'],
        'radius': json['radius'] == null ? undefined : json['radius'],
        'rightZoneId': json['rightZoneId'] == null ? undefined : json['rightZoneId'],
        'signalLink': json['signalLink'] == null ? undefined : json['signalLink'],
    };
}

export function InputAdminZoneToJSON(value?: InputAdminZone | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'allowAdditionalMissionTime': value['allowAdditionalMissionTime'],
        'centerCoordinates': value['centerCoordinates'],
        'dambaIntegration': value['dambaIntegration'],
        'deltaLink': value['deltaLink'],
        'directions': value['directions'] == null ? undefined : ((value['directions'] as Array<any>).map(InputDirectionToJSON)),
        'flightTimeoutMinutes': value['flightTimeoutMinutes'],
        'leftZoneId': value['leftZoneId'],
        'name': value['name'],
        'otgId': value['otgId'],
        'radius': value['radius'],
        'rightZoneId': value['rightZoneId'],
        'signalLink': value['signalLink'],
    };
}

